export const PERMISSIONS = [
  { label: 'Admin', code: 'Admin' },
  { label: 'Home', code: 'Home' },
  { label: 'Vendors', code: 'Vendors' },
  { label: 'Stores', code: 'Restaurants' },
  { label: 'Orders', code: 'Orders' },
  { label: 'Store Sections', code: 'Restaurant Sections' },
  { label: 'Users', code: 'Users' },
  { label: 'Riders', code: 'Riders' },
  { label: 'Staff', code: 'Staff' },
  { label: 'Customer Support', code: 'Customer Support' },
  { label: 'Customer Marketing', code: 'Customer Marketing' },
  { label: 'Configuration', code: 'Configuration' },
  { label: 'Coupons', code: 'Coupons' },
  { label: 'Cuisines', code: 'Cuisines' },
  { label: 'Shop Types', code: 'Shop Types' },
  { label: 'Store Ads', code: 'Restaurant Ads' },
  { label: 'Tipping', code: 'Tipping' },
  { label: 'Zone', code: 'Zone' },
  { label: 'Dispatch', code: 'Dispatch' },
  { label: 'Courier', code: 'Courier' },
  { label: 'Notifications', code: 'Notifications' },
  { label: 'Commission Rates', code: 'Commission Rates' },
  { label: 'Withdraw Requests', code: 'Withdraw Requests' }
]
